import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateChatbotSettings } from './request';
import { CHATBOT_SETTINGS_QUERY_KEY } from '../../queries/chatbot/key';
import toast from 'react-hot-toast';

export const useUpdateChatbotSettings = (onSuccess?: () => void) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: updateChatbotSettings,
    onSuccess: ({ response }) => {
      toast.success(response);
      queryClient.invalidateQueries({ queryKey: [CHATBOT_SETTINGS_QUERY_KEY] });
      onSuccess?.();
    },
    onError: (error: unknown) => {
      const message =
        error instanceof Error
          ? error.message
          : ((error as { response?: { data?: { response?: string } } })
              ?.response?.data?.response ?? 'Failed to update settings');
      toast.error(message);
    },
  });
};
